import React from "react";
import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import TodoListFooter from "./TodoListFooter";
import { RootState } from "../../../../ReduxToolkit/Store";
import { H4, H5, LI, UL } from "../../../../AbstractElements";
import { useTaskList } from "../../../../Features/todo/hooks/useTaskList";
import { useToggleTaskComplete } from "../../../../Features/todo/hooks/useToggleTaskComplete";
import DeleteConfirm from "../../../../Components/Modals/Delete";
import BorderBottom from "../../../BonusUi/CreativeCard/BorderBottom";

export default function TodoList() {
  const { addNewTask } = useSelector((state: RootState) => state.todos);

  const queryClient = useQueryClient();
  const { data, isLoading, isError } = useTaskList();
  const allTodos = data?.list ?? [];
  const toggleMutation = useToggleTaskComplete();

  if (isLoading) return <div className="text-muted">Caricamento...</div>;
  if (isError) return <div className="text-danger">Errore nel caricamento</div>;

  return (
    <div className="todo-list-body">
      {addNewTask && <TodoListFooter />}

      <UL className="simple-list" id="todo-list">
        {allTodos.map((todo) => (
          <LI className="task" key={todo.clientId ?? todo.id}>
            <div style={{ borderBottom: '1px solid grey' }} className="task-container d-flex align-items-center gap-3">
              <div style={{ maxWidth: "70%" }}>
                <H4
                  className="task-label"
                  style={{
                    textDecoration: todo.completato === 1 ? "line-through" : "none",
                    opacity: todo.completato === 1 ? 0.6 : 1,
                  }}
                >
                  {todo.testo}
                </H4>
              </div>

              <div className="d-flex align-items-center gap-4">
                <H5 className="assign-name m-0">{todo.data}</H5>

                <span className="task-action-btn">
                  {todo.cancellato == 0 &&
                    <span className="action-box large delete-btn">
                      <DeleteConfirm
                        url={`/task?ID=${todo.id}`}
                        onSuccess={() => {
                          queryClient.invalidateQueries({ queryKey: ["task-list"] });
                        }}
                        trigger={
                          <i className="icon">
                            <i className="icon-trash" />
                          </i>
                        }
                      />
                    </span>
                  }

                  <span
                    className="action-box large complete-btn"
                    onClick={() =>
                      toggleMutation.mutate({
                        id: todo.id,
                        completato: todo.completato === 1 ? 0 : 1,
                      })
                    }
                  >
                    <i style={{ width: '30px', height: '30px' }} className="icon m-0">
                      <i className="icon-check m-0" />
                    </i>
                  </span>

                </span>
              </div>
            </div>
          </LI>
        ))}
      </UL>
    </div>
  );
}
